<template>
  <div class="info">
    <update-form />
  </div>
</template>

<script setup>
import UpdateForm from "@/components/forms/update-form.vue";
</script>

<style lang="scss" scoped>
.info {
  position: relative;
  z-index: 1;
}
</style>